export type IClearFieldError = (fieldId: string, fieldSuffix?: string) => void;

export function clearFieldError(fieldId: string, fieldSuffix = ''): void {
  const $formGroup = $(`#row_field_${fieldId}${fieldSuffix}`);
  const $input = $formGroup.find(':input');
  const $errorBlock = $formGroup.find(`#error_block_field_${fieldId}${fieldSuffix}`);
  $formGroup.removeClass('has-error has-warning');
  $input.attr('aria-invalid', 'false');
  $errorBlock.addClass('hide').attr('aria-hidden', 'true');
}
